/* eslint-disable max-lines */
import $ from 'jquery';
import messenger from '../../shared/messenger';
import namespace from '../../../smartpak/smartpak';
import orderForm from '../shared/orderform';
import { possessiveName } from '../../../smartpak/misc';
import smartPakItem from '../../../api/smartpakitem';

const productTypes = {
    UNKNOWN: 0,
    SUPPLEMENT: 1,
    TES: 2,
    PORTIONPAK: 3,
    },
    smartPaksOrderForm = {
        _formatData: function (recipientVm) {
            var pak = recipientVm.selectedPak(),
                doseType = pak.selectedDoseTypeId(),
                isCustomDose = doseType === pak.doseTypes.CUSTOM;

            return JSON.stringify({
                CustomFeedingTime: isCustomDose ? pak.selectedFeedingTime() : '',
                DoseType: doseType,
                Dose: !isCustomDose ? '' : pak.isPortionPak ? pak.dosingDescription() : pak.selectedCustomOption().description(),
                ProductId: recipientVm.selectedProductId(),
                IsAutoShip: pak.isAutoShip(),
                AccountName: recipientVm.selectedRecipientName(),
                ProductType: pak.isPortionPak ? productTypes.PORTIONPAK : productTypes.UNKNOWN
            });
        },
        _addToSmartPak: function (recipientVm) {
            return smartPakItem.addSmartPakItem(this._formatData(recipientVm)).done(function (response) {
                if (response.Status === smartPak.HTTP_STATUS_CREATED) {
                    orderForm._fireAddToCartEvent(recipientVm);
                }
            });
        },
        _getSupplementsByAccountId: function (accountId) {
            return smartPakItem.getByAccount(accountId);
        },
        _notSPEUserAndTryingToUseMeForPak: function (viewmodel) {
            return (
                viewmodel.selectedProduct() &&
                !viewmodel.selectedProduct().isTes &&
                !viewmodel.isSPEUser() &&
                /^me$/i.test(viewmodel.selectedRecipientName())
            );
        },
        _showInValidNameError: function () {
            orderForm._showError(
                {
                    View: 'Please enter a valid animal name'
                },
                'Error'
            );
        },
        _miniCartSubmit: function ($form, viewmodel) {
            var $btn = $form.find('input[type=submit]');
            if (this._notSPEUserAndTryingToUseMeForPak(viewmodel)) {
                this._showInValidNameError();
                $btn.prop('disabled', false);
            } else {
                orderForm._submit($form).done(
                    function (response) {
                        orderForm._handleResponse(response);
                        if (orderForm._shouldFireAddToCartEvent(response)) {
                            orderForm._fireAddToCartEvent(viewmodel);
                        }
                        $btn.prop('disabled', false);
                        this._updateRecipientList(viewmodel);
                    }.bind(this)
                );
            }
        },
        _handleSubmit: function ($form, viewmodel) {
            var $button = $form.find('input[type=submit]');

            $button.prop('disabled', true);

            this._submit($form, viewmodel)
                .done(
                    function (response) {
                        this._handleResponse(response, viewmodel);
                    }.bind(this)
                )
                .fail(function () {
                    $button.prop('disabled', false);
                });
        },
        _goToCart: function () {
            smartPak.page.redirectToUrl('/cart/');
        },
        _goToAutoShipManager: function (accountId, productType) {
            smartPak.page.redirectToUrl('/autoshipmanager/supplements/' + accountId + '?productType=' + productType);
        },
        _buildAddedSmartPakMessage: function (productName, recipientName, productTypeName) {
            return productName + ' added to ' + possessiveName(recipientName) + ' ' + productTypeName + '!';
        },
        _handleResponse: function (response, viewmodel) {
            var recipient = viewmodel.selectedRecipient(),
                selectedProduct = viewmodel.selectedProduct(),
                PORTIONPAK_TYPE = 3,
                SMARTPAK_TYPE = 1,
                productType = selectedProduct && selectedProduct.isPortionPak ? PORTIONPAK_TYPE : SMARTPAK_TYPE,
                productTypeName = productType === PORTIONPAK_TYPE ? 'PortionPak' : 'SmartPak',
                messengerInstance;

            if (!recipient) {
                return orderForm._redirectToCart();
            }

            if (
                (productType === PORTIONPAK_TYPE && this._isAddingToExistingPortionPak(viewmodel, recipient)) ||
                (productType === SMARTPAK_TYPE && this._isAddingToExistingSmartPak(viewmodel, recipient))
            ) {
                messengerInstance = messenger.init();

                messengerInstance.confirm(
                    this._buildAddedSmartPakMessage(
                        viewmodel.shortName() ? viewmodel.shortName() : viewmodel.name(),
                        recipient.Name,
                        productTypeName
                    ),
                    true
                );

                return this._goToAutoShipManager(recipient.AccountId, productType);
            }
            return orderForm._redirectToCart();
        },
        _isHorse: function (recipient) {
            var HORSE_TYPE = 1;
            return recipient.AccountType === HORSE_TYPE;
        },
        _isDog: function (recipient) {
            var DOG_TYPE = 2;
            return recipient.AccountType === DOG_TYPE;
        },
        _isAddingToExistingPortionPak: function (viewmodel, recipient) {
            return (
                recipient &&
                this._isDog(recipient) &&
                viewmodel.selectedProduct().isPortionPak &&
                recipient.PortionPak.Supplements.length > 0 &&
                !recipient.HasUnsubmittedPortionPak
            );
        },
        _isAddingToExistingSmartPak: function (viewmodel, recipient) {
            return (
                recipient &&
                (this._isHorse(recipient) || this._isDog(recipient)) &&
                viewmodel.selectedProduct().isSmartPak &&
                recipient.SmartPak.Supplements.length > 0 &&
                !recipient.HasUnsubmittedSmartPak
            );
        },
        _showPendingOTSError: function () {
            smartPak.ui.modal(
                $(
                    '<div class="pam">This horse already has a one-time ship SmartPak that cannot be changed.  Please select a different horse name</div>'
                ).get(0),
                {
                    title: 'Pending SmartPaks',
                    removeContents: true,
                    resizable: false
                }
            );
        },
        _hasPendingOTSSmartPak: function (viewmodel, recipient) {
            return (
                recipient &&
                (this._isHorse(recipient) || this._isDog(recipient)) &&
                viewmodel.selectedProduct().isSmartPak &&
                recipient.HasPendingOTSSmartPak
            );
        },
        _isAddingToExistingPak: function (viewmodel, recipient) {
            return (
                this._isAddingToExistingPortionPak(viewmodel, recipient) ||
                this._isAddingToExistingSmartPak(viewmodel, recipient)
            );
        },
        _isATSSmartPak: function (products) {
            return products.every(product => product.IsAutoShip);
        },
        _containsDuplicateProduct: function (products, productClassId) {
            return products.some(product => product.ProductClassId === productClassId);
        },
        _checkForDuplicateProduct: function (accountId, productClassId) {
            return this._getSupplementsByAccountId(accountId).pipe(({ Content: products }) => {
                return this._isATSSmartPak(products) && this._containsDuplicateProduct(products, productClassId);
            });
        },
        _handleDuplicateProduct: function ($form) {
            $form.find('input[type=submit]').prop('disabled', false);
            orderForm._showDuplicateWarning();
        },
        _formatRecipientData: function (response) {
            return {
                AccountId: response.AccountId,
                AccountType: 1,
                Deleted: response.IsDeleted,
                Name: response.AnimalName,
                SmartPak: {
                    AllSupplementWereRemoved: false,
                    RemovedItemIds: null,
                    StartingSupplementCount: 0,
                    Supplements: []
                }
            };
        },
        _updateRecipientList: function (viewmodel) {
            var hasRecipient = viewmodel.allRecipients().filter(function (recipient) {
                return recipient.Name === viewmodel.selectedRecipientName();
            });

            smartPak.api.recipient.getAllByCurrentCustomer().done(
                function (result) {
                    var recipients = result.Content.filter(function (item) {
                            return item.AnimalName === viewmodel.selectedRecipientName();
                        }),
                        singleRecipient = recipients.map(this._formatRecipientData)[0];

                    if (hasRecipient.length === 0) {
                        viewmodel.allRecipients.push(singleRecipient);
                    }
                }.bind(this)
            );
        },
        _submit: function ($form, viewmodel) {
            var recipient = viewmodel.selectedRecipient(),
                dfd = new $.Deferred(),
                addToSmartPak = function () {
                    this._addToSmartPak(viewmodel).done(dfd.resolve).fail(dfd.reject);
                }.bind(this),
                addToCart = function () {
                    this._miniCartSubmit($form, viewmodel);
                }.bind(this);

            if (recipient) {
                this._checkForDuplicateProduct(recipient.AccountId, viewmodel.id()).done(
                    function (isDuplicateProduct) {
                        if (isDuplicateProduct) {
                            this._handleDuplicateProduct($form);
                            dfd.reject();
                        } else if (this._isAddingToExistingPak(viewmodel, recipient)) {
                            if (!viewmodel.isLoggedIn()) {
                                this._launchLoginModal({
                                    success: addToSmartPak,
                                    fail: dfd.reject
                                });
                            } else {
                                addToSmartPak();
                            }
                        } else {
                            addToCart();
                        }
                    }.bind(this)
                );
            } else {
                addToCart();
            }

            return dfd.promise();
        },
        _launchLoginModal: function (onSuccess) {
            import('../../customeraccount/launchmodal').then(({default: launchModal}) =>
                launchModal({success: onSuccess})
            );
        },
        init: function ($form, viewmodel) {
            if (!$form.length) {
                return;
            }

            orderForm._parseDynamicFormElements($form);

            orderForm.setSubmitHandler(
                $form,
                function () {
                    var recipient = viewmodel.selectedRecipient(),
                        productIsAutoship = viewmodel.selectedProduct().isAutoShip(),
                        $otsWarning = $('.otsWarning'),
                        $button;

                    if (recipient) {
                        if (this._hasPendingOTSSmartPak(viewmodel, recipient)) {
                            this._showPendingOTSError();
                            return;
                        }

                        smartPakItem.getByAccount(recipient.AccountId).done(
                            function (result) {
                                if (result.Status === smartPak.HTTP_STATUS_OK) {
                                    var content = result.Content[0];

                                    if (content) {
                                        if (content.IsAutoShip && !productIsAutoship && content.IsSubmitted) {
                                            $otsWarning.removeClass('jsHide');
                                            return false;
                                        }
                                        $otsWarning.addClass('jsHide');
                                    }

                                    this._handleSubmit($form, viewmodel);
                                }
                                return true;
                            }.bind(this)
                        );
                    } else {
                        $button = $form.find('input[type=submit]');

                        $button.prop('disabled', true);
                        this._miniCartSubmit($form, viewmodel);
                    }
                }.bind(this),
                viewmodel
            );
        }
    };

// make available globally for DY action usage
namespace('productClass').orderForm = orderForm;

export default smartPaksOrderForm;
